import api from './api';

// Notification preference type
export type NotificationPreference = {
  type: string;
  emailEnabled: boolean;
};

// Response from API
export type NotificationPreferencesResponse = {
  preferences: NotificationPreference[];
};

// Notification type labels for display
export const NOTIFICATION_TYPE_LABELS: Record<string, { label: string; description: string }> = {
  ORDER_UPDATES: {
    label: 'Order Updates',
    description: 'Get notified when order status changes',
  },
  NEW_PATIENTS: {
    label: 'New Patients',
    description: 'Get notified when new patients are added',
  },
  WEEKLY_REPORT: {
    label: 'Weekly Report',
    description: 'Receive a weekly summary of activity',
  },
  MARKETING: {
    label: 'Marketing Emails',
    description: 'Receive product updates and news',
  },
};

export const notificationPreferencesService = {
  async getPreferences(): Promise<NotificationPreferencesResponse> {
    const response = await api.get<NotificationPreferencesResponse>('/company/users/me/notification-preferences');
    return response.data;
  },

  async updatePreferences(preferences: NotificationPreference[]): Promise<NotificationPreferencesResponse> {
    const response = await api.put<NotificationPreferencesResponse>('/company/users/me/notification-preferences', {
      preferences,
    });
    return response.data;
  },
};

export default notificationPreferencesService;
